import ruleReducer from "./reducers";

export default ruleReducer;